import { useMyUnresolvedCount } from '@support/entities/support-ticket';
import { Badge } from '@/shared/ui';

// Numeric badge over the header support trigger. Subscribes to
// support.myUnresolvedCount; updates without polling whenever a ticket
// mutation invalidates the query. Renders nothing when the count is 0.
// Mirrors apps/incidents' IncidentCountBadge.
export const SupportTicketCountBadge = () => {
  const { data } = useMyUnresolvedCount();
  if (!data || data === 0) return null;
  return <Badge variant="error">{data}</Badge>;
};
